const problems = [
  {
    n: "01",
    h: "Stock sitting for months",
    p: "Products bought 90 days ago haven't moved. The cash is locked. Every shelf is a silent financial drain.",
    stat: "₹3–8L",
    statSub: "average dead stock per small store annually",
  },
  {
    n: "02",
    h: "Discounting kills your margins",
    p: "You slash prices to clear old stock, but you don't know which products can be discounted safely and which signal a deeper buying mistake.",
    stat: "18–35%",
    statSub: "margin loss from reactive discounting",
  },
  {
    n: "03",
    h: "No clarity on what to reorder",
    p: "Fast movers run out before slow movers are even touched. You reorder based on gut feel, not data — and the cycle repeats.",
    stat: "2x",
    statSub: "more stock bought vs what actually sells",
  },
  {
    n: "04",
    h: "Reports without real decisions",
    p: "Your POS might show sales data but it doesn't tell you what to clear, what to stop buying, or where your cash is actually trapped.",
    stat: "0",
    statSub: "decisions made from most standard reports",
  },
];

export default function ProblemSection() {
  return (
    <div className="sm-section-full sm-section-bg">
      <div className="sm-section">
        <div className="sm-reveal">
          <span className="sm-eyebrow">The Problem</span>
          <h2 className="sm-h2">
            Retailers run on gut feel
            <br />
            when they should run on clarity
          </h2>
          <p className="sm-h2-sub">
            If any of these sound familiar, you're leaving significant cash tied
            up in inventory every month.
          </p>
        </div>

        <div className="sm-problem-grid">
          {problems.map((problem, index) => (
            <div
              key={index}
              className={`sm-problem-card sm-reveal sm-reveal-d${(index % 2) + 1}`}
            >
              <div className="sm-problem-num">{problem.n}</div>
              <h3 className="sm-problem-h3">{problem.h}</h3>
              <p className="sm-problem-p">{problem.p}</p>
              <div className="sm-problem-stat">{problem.stat}</div>
              <div className="sm-problem-stat-sub">{problem.statSub}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}